module.exports = __webpack_public_path__ + "static/OldMansJourney3-015d8d2c1c557f97f8a0d65a1468c10a.png";